<toaster-container [toasterconfig]="toasterConfig"></toaster-container>
<div class="wrapper">
  <div class="container-fluid">
    <ngx-loading-bar [includeSpinner]="false" ref="global"></ngx-loading-bar>
    <hub-app-header></hub-app-header>
    <router-outlet></router-outlet>
  </div>
</div>
<hub-app-footer></hub-app-footer>
